module.exports = __webpack_public_path__ + "static/scopriabitareco_experiences_store-1e9f50136897a00113f8538cc2adb785.jpg";